import {
  Home,
  Heart,
  Users,
  DollarSign,
  Info,
  Ticket,
  Settings,
  type LucideIcon,
} from 'lucide-react';
import { CURRENT_REUNION_SLUG } from './organization';

export interface NavItem {
  label: string;
  href: string;
  icon?: LucideIcon;
  description?: string;
}

export interface NavGroup {
  id: string;
  label: string;
  icon?: LucideIcon;
  href?: string;
  items?: NavItem[];
  roles?: string[];
  requiresAuth: boolean;
  /** If true, only show when user is NOT authenticated */
  publicOnly?: boolean;
}

export const navigationConfig: NavGroup[] = [
  {
    id: 'home',
    label: 'Home',
    icon: Home,
    href: '/home',
    requiresAuth: true,
  },
  {
    id: 'reunion',
    label: 'Reunion',
    icon: Heart,
    requiresAuth: true,
    items: [
      { label: 'Reunion Event', href: `/events/${CURRENT_REUNION_SLUG}`, description: 'Event details and schedule' },
      { label: 'Get Tickets', href: '/tickets', description: 'Purchase tickets and items' },
      { label: 'My Tickets', href: '/my-tickets', description: 'View your tickets and orders' },
      { label: 'Reunion Flyer', href: '/flyer.html', description: 'View the reunion flyer' },
      { label: 'Take Survey', href: '/survey', description: 'Share your reunion preferences' },
      { label: 'Redd Quest', href: '/quest', description: 'Explore and learn family history' },
    ],
  },
  {
    id: 'tickets',
    label: 'Tickets',
    icon: Ticket,
    href: '/tickets',
    requiresAuth: false,
    publicOnly: true,
  },
  {
    id: 'donate',
    label: 'Donate',
    icon: Heart,
    href: '/donations',
    requiresAuth: false,
    publicOnly: true,
  },
  {
    id: 'finances',
    label: 'Finances',
    icon: DollarSign,
    requiresAuth: true,
    items: [
      { label: 'Dues', href: '/dues', description: 'View and pay family dues' },
      { label: 'Donate', href: '/donations', description: 'Support family campaigns' },
    ],
  },
  {
    id: 'family',
    label: 'Family',
    icon: Users,
    requiresAuth: true,
    items: [
      { label: 'Family Tree', href: '/family', description: 'Explore the Redd family tree' },
      { label: 'Directory', href: '/directory', description: 'Browse family members' },
      { label: 'Documents', href: '/documents', description: 'Family documents and files' },
      { label: 'Photo Gallery', href: '/gallery', description: 'Family photos and videos' },
    ],
  },
  {
    id: 'admin',
    label: 'Admin',
    icon: Settings,
    href: '/admin',
    requiresAuth: true,
    roles: ['admin', 'organizer'],
  },
  {
    id: 'about',
    label: 'About',
    icon: Info,
    requiresAuth: false,
    items: [
      { label: 'About Us', href: '/about' },
      { label: 'Meet the Officers', href: '/officers' },
      { label: 'News', href: '/news' },
      { label: 'Contact Us', href: '/contact' },
    ],
  },
];
